export default angular
  .module('app.formatting')
  .factory('HoldingFormatting', HoldingFormatting)
  .name;

function HoldingFormatting() {
  'ngInject';

  return {
    formatNumber,
    formatNumberWithOriginalDecimals,
  };

  function formatNumber(input, decimals = 3) {
    const number = parseFloat(input);
    if (isNaN(number)) {
      return '';
    }

    const negative = number < 0;
    const parts = Math.abs(number).toFixed(decimals).split('.');

    let formatted = parts[0].split('')
      .reverse()
      .reduce((origRes, part, indx) => {
        const res = origRes + (((indx > 0) && (indx % 3 === 0)) ? ',' : '');
        return res.concat(part);
      }, '')
      .split('')
      .reverse()
      .join('');

    formatted += parts[1] ? `.${parts[1]}` : '';

    const sign = negative ? '-' : '';

    return { sign, formatted };
  }

  function formatNumberWithOriginalDecimals(input) {
    const number = parseFloat(input);
    if (isNaN(number)) {
      return '';
    }

    const negative = number < 0;
    const parts = Math.abs(number).toString().split('.');

    let formatted = parts[0].split('')
      .reverse()
      .reduce((res, part, indx) => {
        const separator = indx > 0 && indx % 3 === 0 ? ',' : '';
        return res.concat(separator).concat(part);
      }, '')
      .split('')
      .reverse()
      .join('');

    formatted += parts[1] ? `.${parts[1]}` : '';

    const sign = negative ? '-' : '';

    return { sign, formatted };
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/formatting/services/formatting.js